var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-0 px-1 px-sm-3 pb-3 maintenance-page",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }